import { PropsWithChildren, forwardRef } from 'react';
import { Tooltip, TooltipArrow, useTooltip } from 'ui-components';
import { IconMenuOption } from './IconMenuOption';

type Props = {
  testId?: string;
  name: string;
  tooltipLabel: string;
  onClick?: () => void;
  className?: string;
  target?: string;
  href?: string;
};

const IconMenuOptionWithTooltipComponent = (
  {
    children,
    name,
    tooltipLabel,
    onClick,
    testId = '',
    href,
    target,
    className,
    ...rest
  }: PropsWithChildren<Props>,
  ref
) => {
  const {
    context: tooltipContext,
    isOpen: tooltipIsOpen,
    refs: tooltipRefs,
    floatingStyles: tooltipFloatingStyles,
    getReferenceProps: getTooltipReferenceProps,
    getFloatingProps: getTooltipFloatingProps,
    arrowRef: tooltipArrowRef,
  } = useTooltip({
    offset: 8,
    arrow: true,
  });

  return (
    <>
      <IconMenuOption
        name={name}
        testId={testId}
        href={href}
        target={target}
        className={className}
        ref={(el: any) => {
          tooltipRefs.setReference(el);
          if (ref && typeof ref === 'function') {
            ref(el);
          } else if (ref && typeof ref === 'object') {
            ref.current = el;
          }
        }}
        {...getTooltipReferenceProps()}
        onClick={onClick}
        {...rest}
      >
        {children}
      </IconMenuOption>
      {tooltipIsOpen && (
        <div
          ref={tooltipRefs.setFloating}
          style={tooltipFloatingStyles}
          {...getTooltipFloatingProps()}
        >
          <TooltipArrow arrowRef={tooltipArrowRef} context={tooltipContext} />
          <Tooltip label={tooltipLabel} />
        </div>
      )}
    </>
  );
};

export const IconMenuOptionWithTooltip = forwardRef(
  IconMenuOptionWithTooltipComponent
);
